<template>
  <div id="post-filter-category-select">
    <label class="form-label">Категория</label>
    <Multiselect @change="onChange" v-model="fields.category_id" mode="tags" placeholder="Не выбрано" noResultsText="Результатов не найдено" :close-on-select="true" :options="getValues()" :searchable="true" :trackBy="'title'">
      <template v-slot:tag="{ option, handleTagRemove, disabled }">
        <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
          <img :src="option.image">
          <div class="user-name">{{ option.title }}</div>
          <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
            <span class="multiselect-tag-remove-icon"></span>
          </span>
        </div>
      </template>
      <template v-slot:option="{ option }">
        <div class="option-user">
          <div class="user-image-wrap">
            <img class="user-image" :src="option.image">
          </div>
          <div class="user-name">
            {{ option.title }}
            <div class="item-path">
              <span class="item-level" :class="'level-' + option.level"></span>
              {{ option.path }}
            </div>
          </div>
        </div>
      </template>
    </Multiselect>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, watch, ref, onMounted, reactive} from "vue"
import Multiselect from "@/plugins/multiselect"
import CatalogImage from "./services/CatalogImage"
import Api from "@/modules/post/components/filter/components/category/services/Api"

export default defineComponent({
  name: "Category",
  components: {
    Multiselect,
  },
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    let categoriesValues = ref([])

    const fields = reactive({
      category_id: props.data.val,
    })

    onMounted(async () => {
      fields.category_id = props.data.val

      let categories = await Api.categories()

      setValues(categories);
    })

    watch(() => props.data.val, (val) => {
      fields.category_id = val
    })

    watch(() => props.data.categories, (val) => {
      setValues(val)
    })

    function setValues(items) {
      let filtered = []

      for (let prop in items) {
        let obj = items[prop]
        let image = CatalogImage.handle(obj["category_image_host"], obj["category_image_name"], 60, 60)

        filtered.push({
          value: obj["category_id"],
          title: obj["category_name"],
          image: image,
          path: obj["category_str_path"],
          level: obj["category_level"],
        })
      }

      categoriesValues.value = filtered
    }

    function getValues() {
      return categoriesValues.value;
    }

    function onChange(value) {
      fields.category_id = value
      emit("onChange", fields.category_id)
    }

    return {
      onChange,
      getValues,
      fields,
    }
  }
})
</script>
